import { useLabelsField } from '@atlassian/jira-issue-field-labels';
import { LABELS_TYPE, LABELS_CF_TYPE } from '@atlassian/jira-platform-field-config';
import { useGenericClipboardHandler } from '../../../clipboard-handler/utils';
import type {
	ClipboardItem,
	ListIssueFieldTransformed,
	PasteHandler,
	PasteMetadata,
} from '../../../types';
import { createClipboardHelperComponent } from '../../utils';

const getPastedValue = (
	clipboardItem: ClipboardItem,
	metadata: PasteMetadata | null,
): string[] | null => {
	if (!clipboardItem || !clipboardItem.plainText) {
		return null;
	}

	if (
		metadata?.fieldType &&
		metadata?.fieldType !== LABELS_TYPE &&
		metadata?.fieldType !== LABELS_CF_TYPE
	) {
		return null;
	}

	return clipboardItem.plainText.split(',').map((label) => label.trim());
};

const useLabelsClipboardHandler: PasteHandler = (
	issue: { key: string; issueId: string },
	field: ListIssueFieldTransformed,
) => {
	const [, { saveValue }] = useLabelsField({
		issueKey: issue.key,
		issueId: issue.issueId,
		fieldKey: field?.fieldId,
	});

	return useGenericClipboardHandler(field, getPastedValue, saveValue);
};

const LabelsClipboardHelper = createClipboardHelperComponent(useLabelsClipboardHandler);

export const labelsClipboardHandler = {
	[LABELS_TYPE]: LabelsClipboardHelper,
	[LABELS_CF_TYPE]: LabelsClipboardHelper,
};
